module.exports = __webpack_public_path__ + "img/project-7.d843d294.jpg";